import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { calculateRgba } from "../../../utils";
import { scaleMobile } from "../../scale";

function bannerContentInlineStyleInner(_ref) {
  var _ref$layout = _ref.layout,
      type = _ref$layout.type,
      dialogMaxWidth = _ref$layout.dialogMaxWidth,
      dialogPosition = _ref$layout.dialogPosition,
      dialogMargin = _ref$layout.dialogMargin,
      bannerPosition = _ref$layout.bannerPosition,
      dialogBorderRadius = _ref$layout.dialogBorderRadius,
      _ref$design = _ref.design,
      borderWidth = _ref$design.borderWidth,
      borderColor = _ref$design.borderColor,
      textAlign = _ref$design.textAlign,
      fontColor = _ref$design.fontColor,
      fontInheritFamily = _ref$design.fontInheritFamily,
      fontFamily = _ref$design.fontFamily,
      fontWeight = _ref$design.fontWeight,
      boxShadowEnabled = _ref$design.boxShadowEnabled,
      boxShadowOffsetX = _ref$design.boxShadowOffsetX,
      boxShadowOffsetY = _ref$design.boxShadowOffsetY,
      boxShadowBlurRadius = _ref$design.boxShadowBlurRadius,
      boxShadowSpreadRadius = _ref$design.boxShadowSpreadRadius,
      boxShadowColor = _ref$design.boxShadowColor,
      boxShadowColorAlpha = _ref$design.boxShadowColorAlpha,
      individualLayout = _ref.individualLayout,
      antiAdBlocker = _ref.customCss.antiAdBlocker,
      mobile = _ref.mobile,
      pageRequestUuid4 = _ref.pageRequestUuid4,
      individualPrivacyOpen = _ref.individualPrivacyOpen;
  var mobileAlignment = mobile.alignment;
  var useType = scaleMobile(mobile, pageRequestUuid4, type, "banner");
  var useBorderWidth = scaleMobile(mobile, pageRequestUuid4, borderWidth);
  var width = useType === "dialog" ? +(individualPrivacyOpen && !individualLayout.inheritDialogMaxWidth ? individualLayout.dialogMaxWidth : dialogMaxWidth) : "100%";

  var style = _defineProperty({
    pointerEvents: "all",
    transition: "width 500ms, max-width 500ms",
    maxWidth: width,
    textAlign: textAlign,
    width: width,
    overflow: "hidden",
    alignSelf: scaleMobile(mobile, pageRequestUuid4, useType === "banner" ? bannerPosition === "top" ? "flex-start" : "flex-end" : undefined, mobileAlignment === "bottom" ? "flex-end" : mobileAlignment === "top" ? "flex-start" : "center"),
    fontFamily: fontInheritFamily ? undefined : fontFamily,
    fontWeight: fontWeight,
    color: fontColor,
    margin: useType === "dialog" ? 10 : undefined,
    borderRadius: useType === "dialog" ? +dialogBorderRadius : undefined,
    boxShadow: boxShadowEnabled ? "".concat(boxShadowOffsetX, "px ").concat(boxShadowOffsetY, "px ").concat(boxShadowBlurRadius, "px ").concat(boxShadowSpreadRadius, "px ").concat(calculateRgba(boxShadowColor, boxShadowColorAlpha)) : undefined
  }, useType === "banner" ? bannerPosition === "top" ? "borderBottom" : "borderTop" : "border", useType === "banner" ? useBorderWidth > 0 ? "".concat(useBorderWidth, "px solid ").concat(borderColor) : undefined : undefined);

  if (useType === "dialog" && dialogPosition !== "middleCenter") {
    style.margin = dialogMargin.map(function (i) {
      return "".concat(i, "px");
    }).join(" ");
  }

  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-inner",
    style: style
  };
}

export { bannerContentInlineStyleInner };